import { fromPromise } from 'xstate';

import { OrderTypeValues } from '@sg/shared-be-features-ordering';

import { getLocalStorageOrderId } from '@order/features-ordering';

import {
  type ConfirmPaymentInput,
  type ConfirmPaymentResponse,
  type FetchPaymentInfoResponse,
  type FetchPendingPaymentResponse,
} from './sweetpass-checkout.machine.types';

// ─── External Actors ─────────────────────────────────────────────────────────

const fetchPaymentInfo = fromPromise<FetchPaymentInfoResponse>(async () => {
  throw new Error('Please implement the {fetchPaymentInfo} actor.');
});

const confirmPayment = fromPromise<ConfirmPaymentResponse, ConfirmPaymentInput>(async () => {
  throw new Error('Please implement the {confirmPayment} actor.');
});

// ─── Internal Actors ─────────────────────────────────────────────────────────

/**
 * Reads a pending sweetpass payment stored on payment intent creation, so the
 * checkout can resume polling it, e.g. after being redirected from home.
 */
const fetchPendingPayment = fromPromise<FetchPendingPaymentResponse>(async () => {
  const { orderId, orderType } = await getLocalStorageOrderId();

  if (orderType !== OrderTypeValues.SweetpassOrder || !orderId) {
    return { hasPendingPayment: false };
  }

  return { hasPendingPayment: true, orderId };
});

// ─────────────────────────────────────────────────────────────────────────────

export const Actors = {
  fetchPaymentInfo,
  fetchPendingPayment,
  confirmPayment,
};
